import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { WorkspaceIconsModule } from './workspace-icons.module';

const SUCCESS = new Set([
  'accepted',
  'verified',
  'active',
  'ready',
  'final',
  'succeeded',
  'digitized',
  'match',
]);

const PENDING = new Set([
  'open',
  'uploaded',
  'pending_verify',
  'under_review',
  'pending',
]);

const VIOLATION = new Set(['rejected', 'failed', 'recheck_requested', 'mismatch']);

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule, WorkspaceIconsModule],
  template: `
    <span class="badge" [ngClass]="[statusCd, size]">
      <lucide-icon [name]="iconName()" [size]="iconSize()" [strokeWidth]="2.25" />
      <ng-content />
    </span>
  `,
})
export class StatusBadgeComponent {
  @Input({ required: true }) statusCd = '';
  @Input() size: '' | 'lg' = '';

  iconSize(): number {
    return this.size === 'lg' ? 14 : 12;
  }

  iconName(): string {
    const key = (this.statusCd || '').toLowerCase();
    if (SUCCESS.has(key)) return 'circle-check';
    if (PENDING.has(key)) return 'clock';
    if (VIOLATION.has(key)) return 'triangle-alert';
    return 'circle';
  }
}
